/**
 * BettingPoolButton Component
 * Simple button to open betting pool modal from GameMarketView
 */

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import BettingPoolEntry from './BettingPoolEntry';
import { Coins } from 'lucide-react';
import './BettingPoolButton.css';

const BettingPoolButton = ({ game, userBet }) => {
  const [showModal, setShowModal] = useState(false);

  // Extract AI prediction data from game
  const aiPrediction = {
    consensus: game.consensus,
    consensusConfidence: game.consensusConfidenceNumeric || game.consensusConfidence || game.avgConfidenceNumeric || 50,
    marketStrength: game.marketStrength
  };

  const handleOpenPool = (e) => {
    e.stopPropagation(); // Prevent card expansion
    setShowModal(true);
    // Prevent body scroll on mobile when modal is open
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // Re-enable body scroll
    document.body.style.overflow = '';
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      // Ensure body scroll is re-enabled if component unmounts while modal is open
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <>
      <button
        className={`betting-pool-btn ${userBet ? 'has-bet' : ''}`}
        onClick={handleOpenPool}
        title={userBet ? `You bet ${userBet.amount} on ${userBet.team}` : "Bet on this game"}
      >
        <Coins size={14} />
        <span>Bet</span>
      </button>

      {showModal && ReactDOM.createPortal(
        <div className="betting-pool-modal-overlay" onClick={handleCloseModal}>
          <div className="betting-pool-modal-content" onClick={(e) => e.stopPropagation()}>
            <BettingPoolEntry
              game={game}
              aiPrediction={aiPrediction}
              onClose={handleCloseModal}
            />
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default BettingPoolButton;